import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import {
  canShowRangeSwitch,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _, { each } from "lodash";
import { isEvGroup } from "../reports/summaryReport";
import actions from "../../../store/actions";
// import { processData } from "./dailyReport";
import { changeToHours } from "../reports/aggregatedReport";

const processData = (dataArray, vehicleMap, callback) => {
    
    const historyData = [];
    
    // Process each item in the array
    for (const item of dataArray) {
      const starttime = item.starttime ? new Date(item.starttime) : null;
      const endtime = item.endtime ? new Date(item.endtime) : 
                     (item.endedtime ? new Date(item.endedtime) : null);
      let duration = "N/A";
      if (starttime && endtime && endtime > starttime) {
          const durationInMins = (endtime - starttime) / (60 * 1000);
          duration = changeToHours(durationInMins);
      }
      historyData.push({
          vehicleno: item.vehicleno,
          starttime,
          endtime,
          startsoc: item.startsoc ?? null,
          endsoc: item.endsoc ?? null,
          soc_gained: item.soc_gained ?? null,
          start_dte: item.start_dte ?? null,
          end_dte: item.end_dte ?? null,
          duration
      });
    }
    callback(historyData);
  };
  
const getChargeHistory = (schema, data, store) => {
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let saveState = null;
  let tableStateData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 15) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 15 days",
        content: "You can't select date range of more than 15 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    let vehicleIds = data.vehicle.map((vehicle) => {   
      return vehicle.data.vehicleno;
    });
    let body = {
        vehicles: vehicleIds,
      starttime: starttime,
      endtime: endtime,
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    
    ReportAPIs.getChargingHistoryReport(body)
      .then((resp) => {
        window.dataForAll = resp;
        window.dataForAll = resp;
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        processData(resp, store.vehicleMap, (data) => {
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          if (schema.content[0].ref) {
            schema.content[0].ref.setData(data);
          }
        });
      })
      .catch(() => {
        console.log("something went wrong");
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        schema.content[0].ref.setBusy(false);
      });
  }
};
const download = (schema) => {
  if (schema.content[0].ref) {
    JSONToCSVConvertor(
      schema.content[0].ref.getData(true),
      "Charge History Report",
      false
    );
  }
};
const schema = {
  key: "zap_report",
  name: "Zap Report",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount : 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      // hideTime: true,
      schemaKey: "charge_history_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      // hideTime: true,
      schemaKey: "charge_history_report",
    },
    {
      key: "get_Charge_history",
      type: schemaTypes.BUTTON,
      name: "Get Zap Report",
      onClick: getChargeHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        {
          key: "vehicleno",
          name: "Vehicle No",
        },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        { key: "duration", name: "Duration" },
        // { key: "chargetype", name: "Charge Type" },
        { key: "startsoc", name: "Start SoC" },
        { key: "endsoc", name: "End SoC" },
        {key: "soc_gained", name: "Soc Gained"},
        // { key: "totalsoc", name: "Total SoC" },
        {key: "start_dte",name:"Start Dte"},
        {key: "end_dte", name:"End Dte"}
      ],
    },
  ],
};
export default schema;